import * as Sentry from '@sentry/react';
import { CatchBoundary, createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import { ErrorPage } from '@/components/error-page';
import { Toaster } from '@/components/ui/sonner';
import { RouterContext } from '@/lib/router';

const RootComponent = () => (
  <CatchBoundary
    getResetKey={() => 'root'}
    errorComponent={({ error }) => <ErrorPage error={error} />}
    onCatch={(error) => {
      Sentry.captureException(error);
    }}
  >
    <Outlet />
    <Toaster />
  </CatchBoundary>
);

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});
